 
/* ****************************************
* GRIND PICKER
*
***************************************** */  
 function initGrindPickerVariants() {
   const beansControlInput = 'input:radio[data-grind-picker-control="beans"]'
   const groundControlInput = 'input:radio[data-grind-picker-control="ground"]'
   const groundOptionInput = 'input:radio[data-grind-picker-grind-option]'
    
  
   function _handleBeansInputChange () {
     if ($(beansControlInput).prop('checked')) {
       $('#mc_grind_options').removeClass('active')
       $(groundControlInput).prop('checked', false)
     }
   }
  
   function _handleGroundInputChange () {
     if ($(groundControlInput).prop('checked')) {
      $('#mc_grind_options').addClass('active')
      $(beansControlInput).prop('checked', false)
      $(groundOptionInput).each(function (index) { 
        if (index ===0 ) $(this).prop('checked', true).trigger('change'); 
        // $(this).click()
      })
     }
   }
   
    $(beansControlInput).on('change', _handleBeansInputChange)
  
    $(groundControlInput).on('change', _handleGroundInputChange)   
  }


/* ****************************************
* SUBSCRIPTION COMPONENT PICKER
*
***************************************** */
function initSubscriptionsComponentPicker () {

  function duplicateProperties () {
  	const settingsEl = $('[data-component-picker-settings]')
      const pickerStyle = settingsEl.data('component-picker-style')
      const hiddenComponetIds = (settingsEl.data('component-ids') || "")
        .split(",")
        .filter(x => x.indexOf("_") === 0)
        .map(x => {
          const [id, label] = x.replace(/^\s+|\s+$/g, '').split(':')
          return { id, label }
        })

      hiddenComponetIds.forEach(({ id, label }) => {
        let selectedLabel
        let selector = `[name="properties[${label}]"]`
        if (pickerStyle === 'radio') selectedLabel = $(`input:radio[name="properties[${id}]"]:checked`).data("product-component-option-label")
        if (pickerStyle === 'select') selectedLabel = $(`select[name="properties[${id}]"]`).find(":selected").data("product-component-option-label")

        $(selector).val(selectedLabel)
      })
  }
  
  // Bind listener
  $('[data-product-component]').on('change', duplicateProperties)

  // Set inital values
  duplicateProperties()
  
  try{
    let append = $(document.createElement("span"))
    append.css("display", "none").attr('data-hello-appstle', 'Hello from Mahalia Coffee')
    $($('.appstle_stand_alone_selector')[0]).append(append)
  } catch (e) {}
}


